import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class GetVehicleNewsUseCase extends UseCase {
  /**
   * @constructor
   */
  constructor({getFormattedNewsTagService, getVehicleNewsService}) {
    super()
    this._getFormattedNewsTagService = getFormattedNewsTagService
    this._getVehicleNewsService = getVehicleNewsService
  }

  @tracer({metric: 'GetVehicleNewsUseCase#execute'})
  @inlineError
  async execute({count, make, model, year}) {
    const tags = [make, model]
    const [formattedNewsTagError, formattedNewsTagResponse] = await this._getFormattedNewsTagService.execute({tags})

    if (formattedNewsTagError) return Promise.reject(formattedNewsTagError)

    const [makeTagVO, modelTagVO] = formattedNewsTagResponse.getItems()

    const [vehicleNewsError, vehicleNewsResponse] = await this._getVehicleNewsService.execute({
      count,
      make: makeTagVO.getTag(),
      model: modelTagVO.getTag(),
      year
    })

    if (vehicleNewsError) return Promise.reject(vehicleNewsError)
    return vehicleNewsResponse.toJSON()
  }
}
